/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentCategoryDto } from '../../models/content-category-dto';

export interface AdminContentCategoryControllerFindAllParent$Params {
  filtered: Array<string>;
}

export function adminContentCategoryControllerFindAllParent(http: HttpClient, rootUrl: string, params: AdminContentCategoryControllerFindAllParent$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, adminContentCategoryControllerFindAllParent.PATH, 'get');
  if (params) {
    rb.query('filtered', params.filtered, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentCategoryDto>>;
    })
  );
}

adminContentCategoryControllerFindAllParent.PATH = '/api/content-category/admin/parent';
